var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 800 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .icon-menu-top, .icon-menu-bottom {\n          stroke-dasharray: 240px 950px;\n      }\n      .icon-menu-middle {\n        stroke-dasharray: 240px 240px;\n      }\n      .icon-menu-top, .icon-menu-bottom, .icon-menu-middle {\n        fill: none;\n        transition: stroke-dashoffset .5s cubic-bezier(.25,-.25,.75,1.25),stroke-dasharray .5s cubic-bezier(.25,-.25,.75,1.25);\n        stroke-width: 40px;\n        stroke-linecap: round;\n        stroke-dashoffset: 0px;\n      }\n      .cross .icon-menu-bottom, .cross .icon-menu-top {\n        stroke-dashoffset: -650px;\n      }\n      .cross .icon-menu-middle {\n        stroke-dashoffset: -115px;\n        stroke-dasharray: 1px 220px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-menu-top",
    d: "M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-menu-middle",
    d: "M300,320 L540,320"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "icon-menu-bottom",
    d: "M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190",
    transform: "translate(480, 320) scale(1, -1) translate(-480, -318) "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.929efe4c3c281abaab17a06d17842c51.svg";
export { ForwardRef as ReactComponent };